export default __webpack_public_path__ + "static/media/standing_on_horses.20ff4dae.jpg";